
import { memo, useContext, useEffect, useMemo } from 'react';
import { CloseButton, Container, Iframe, IframeContainer } from './styles';
import { useAppDispatch, useAppSelector } from '../../../../../common/store';
import { sendMessageLogSubmission } from '../../../../../common/store/chat/thunks/send-message-log';
import VurbalizeEvents from '../../../../../common/types/dto/chat/vurbalize-events';
import getMessageByVurablizeEvent from '../../../../utils/get-message-by-vurablize-event';
import { closeBookAppointment } from '../../../../../common/store/theme/theme-slice';
import { postCallSchedules } from '../../../../../common/store/chat/thunks/post-call-scheduled';
import { ChatContext } from '../../../../contexts/chat-context';
import { setHubSpotMeetingScheduled } from '../../../../../common/store/app-state/app-state-slice';

const HubspotCalendar = () => {
  const { bookAppointmentDetails, isOpenBookAppointment } = useAppSelector((state) => state.theme.themeConfig);
  const hubspotMeetingScheduled = useAppSelector((state)=> state['app-state'].hubspotMeetingScheduled);
  const appState = useAppSelector((state)=> state['app-state']);
  const dispatch = useAppDispatch();
  const { sendMessageToServer } = useContext(ChatContext);

  useEffect(() => {
    if (!isOpenBookAppointment) return;

    dispatch(sendMessageLogSubmission({
      data: {
        message: getMessageByVurablizeEvent(VurbalizeEvents.HUBSPOT_CALENDAR_OPEN),
        event_name: VurbalizeEvents.HUBSPOT_CALENDAR_OPEN,
        event_data: {
          timestamp: Date.now(),
          currentUrl: window.location.href
        },
      }
    }));
  }, [isOpenBookAppointment]);

  const closeModal = async () => {
    dispatch(closeBookAppointment());

    if (!hubspotMeetingScheduled) {
      if (sendMessageToServer) {
        sendMessageToServer({
          message: "Operator:[User has not scheduled the call, Tell them the can schedule call anytime they want, how can I help you?]"
        });
      }

      dispatch(sendMessageLogSubmission({ data: {
        message: getMessageByVurablizeEvent(VurbalizeEvents.HUBSPOT_CALENDAR_CLOSE),
        event_name: VurbalizeEvents.HUBSPOT_CALENDAR_CLOSE,
        event_data: {
          timestamp: Date.now(),
          currentUrl: window.location.href
        },
      }}))
      return;
    };

    dispatch(postCallSchedules())
    if (sendMessageToServer ) {
      sendMessageToServer({ message: "Operator:[User has scheduled the call, thank the user]" })
    }
  };

  const closeOnSuccess = async () => {
    dispatch(closeBookAppointment());
    dispatch(postCallSchedules())
    if (sendMessageToServer) {
      sendMessageToServer({ message: "Operator:[User has scheduled the call, thank the user]", appState })
    }
  };

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.meetingBookSucceeded) {
        dispatch(setHubSpotMeetingScheduled(true));
        setTimeout(closeOnSuccess, 1000);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const cookies = useMemo(() => {
    const map = new Map<string, string>();

    document.cookie
      .split(';')
      .forEach(pair => {
        const [key, value] = pair.trim().split('=')
        if (key) {
          map.set(key, value);
        }
      });

    return map;
  }, []);

  const iframeUrl = useMemo(() => {
    const country = cookies.get('userCountry');

    return `${bookAppointmentDetails?.link}?embed=true&email=${bookAppointmentDetails?.userDetails.email}&firstname=${bookAppointmentDetails?.userDetails.firstname}&lastname=${bookAppointmentDetails?.userDetails.lastname}${country ? `&country__c=${country}` : ''}`
  }, [
    bookAppointmentDetails?.link,
    bookAppointmentDetails?.userDetails,
    cookies,
  ]);

  return (
    <Container>
      <CloseButton onClick={closeModal}>
        ✕
      </CloseButton>
      {bookAppointmentDetails?.link &&
        <IframeContainer
          className="meetings-iframe-container"
        >
          <Iframe src={iframeUrl} />
        </IframeContainer>
      }
      <script type="text/javascript" src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"></script>
    </Container>
  );
};

export default HubspotCalendar;
